<template>
  <ul>
    <li class="heading">
      <h1>Notifications</h1>
    </li>
    <li class="badge">
      <h2>{{ notCount }}</h2>
    </li>
    <li class="marking-button"><a href="#" @click="mark">Mark all as read</a></li>
  </ul>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    notifications: Array
  },
  data(){
    return {
      n: this.notifications,
      notCount: 3
    }
  },
  methods: {
    mark(){
      for(let i = 0; i < this.n.length; i++) {
        this.n[i].isReaded = true
      }
      this.notCount = 0
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;800&display=swap');

ul {
  background: hsl(0, 0%, 100%);
  padding: 10px;
  margin-bottom: 40px;
}

ul li {
  display: inline;
  vertical-align: middle;
}

.heading {
  display: inline-block;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1.8rem;
  font-weight: 800;
  color: hsl(224, 21%, 14%);
  vertical-align: middle;
  margin-right: 10px;
}

.badge h2 {
  display: inline-block;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1rem;
  font-weight: 800;
  background: hsl(219, 85%, 26%);
  color: hsl(0, 0%, 100%);
  padding: 6px 12px;
  border-radius: 8px;
  vertical-align: middle;
}

.marking-button {
  float: right;
  display: inline-block;
  font-family: 'Plus Jakarta Sans', sans-serif;
  padding-top: 10px;
}

.marking-button a {
  text-decoration: none;
  color: hsl(219, 12%, 42%);
  vertical-align: middle;
}

.marking-button a:hover {
  color: hsl(219, 85%, 26%);
}

@media only screen and (max-width: 440px){
  .heading{
    font-size: 1.4rem;
  }

  .badge h2{
    font-size: 0.8rem;
  }

  .marking-button {
    padding-top: 3px;
  }
}
</style>